import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'chamiliElafronApostrofos';
const args = {};

export class ChamiliElafronApostrofos extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
